module.exports = __webpack_public_path__ + "media/ets/5-288c3f0b.png";